(function (app, $) {
    $(document).ready(function () {
        if ($('.page_password').length > 0) {
            var password_regex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\W_])([a-zA-Z0-9\W_]{8,16})$/;

            $('#password_form').on('submit', function (e) {
                $('#form_errors').addClass('d-none');

                var password = $('#password').val();
                var confirm = $('#confirmPassword').val();
                if (!password.match(password_regex)) {
                    e.preventDefault();
                    $('#form_errors').text(app.resources.passworderrorregex);
                    $('#form_errors').removeClass('d-none');
                    return false;
                }
                else if (password != confirm) {
                    e.preventDefault();
                    $('#form_errors').text(app.resources.paswworderrorconfirmation);
                    $('#form_errors').removeClass('d-none');
                    return false;
                }

                return true;
            });
        }
    });
})(window.app = window.app || {}, jQuery);